import { render, staticRenderFns } from "./PermissionsSelector.vue?vue&type=template&id=04c1f830&scoped=true&"
import script from "./PermissionsSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsSelector.vue?vue&type=style&index=0&id=04c1f830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1f830",
  null
  
)

export default component.exports